// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__8IFBn","FooterText":"Footer_FooterText__uIRMW","FooterContentWrapper":"Footer_FooterContentWrapper__HnwAE"};